<template>
  <div class="wrap">
    <div class="caption">
      ご登録のメールアドレスにパスワードの再設定メールをお送りいたしました。<br />
      メールに記載のURLから再設定の手続きを行ってください。
    </div>
    <div class="btn-wrap">
      <button class="btn to-login-btn"
              @click="$router.replace({ name: 'login' })">
        ログイン画面へ
      </button>
    </div>    
  </div>

</template>

<script>
export default {
  name: 'Complete'
}
</script>

<style scoped>
.wrap {
  width: 500px;
  margin: auto;
  padding: 1rem;
  text-align: center;
}
.caption {
  font-size: 1.4rem;
  font-weight: bold;
  margin: 3rem 0 6rem 0;
  text-align: left;
}
.btn-wrap {
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.to-login-btn {
  background-color: #333;
  color: white;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>